// src/seo/meta.js
const SUFFIX = " | Bio-Technofix";
const MAX_TITLE = 60;
const MIN_DESC = 140;
const MAX_DESC = 158;

const clean = (s) =>
  (s || "")
    .split("")
    .map((character) => (character.charCodeAt(0) < 32 ? " " : character))
    .join("")
    .replace(/\s+/g, " ")
    .trim();

const truncate = (s, max) => {
  const t = clean(s);
  if (t.length <= max) return t;
  return t.slice(0, max - 1).replace(/[\s,;:.-]+\S*$/, "") + "…";
};

const productDescription = (article, categoryLabel) => {
  const notes = clean(article.description);
  const hasNotes = notes && notes !== "0";
  const label = clean(article.label);
  const category = clean(categoryLabel);
  const brand = clean(article.brandName);

  let description = hasNotes
    ? notes
    : `${label}${category ? `, produit de la catégorie ${category}` : ""}.`;

  if (brand && !description.toLowerCase().includes(brand.toLowerCase())) {
    description += ` Marque ${brand}.`;
  }

  const complements = [
    " Retrouvez ce produit de laboratoire chez Bio-Technofix.",
    " Demandez votre devis en ligne.",
    " Livraison rapide partout en France.",
    " Conseils personnalisés pour les professionnels.",
  ];

  for (const complement of complements) {
    if (clean(description).length >= MIN_DESC) break;
    description += complement;
  }

  const truncated = truncate(description, MAX_DESC);
  if (truncated.length >= MIN_DESC || clean(description).length <= MAX_DESC) {
    return truncated;
  }

  return `${clean(description).slice(0, MAX_DESC - 1).trimEnd()}…`;
};

/** Fiche produit */
export function productMeta(a, categoryLabel = "") {
  const brand = clean(a.brandName);
  const reference = a.crmId ? `Réf. ${clean(a.crmId)}` : "";
  const fixedTail = [reference, brand].filter(Boolean).join(" – ");
  const availableLabelLength = Math.max(
    12,
    MAX_TITLE - SUFFIX.length - (fixedTail ? fixedTail.length + 3 : 0),
  );
  const label = truncate(clean(a.label), availableLabelLength);
  const title = `${label}${fixedTail ? ` – ${fixedTail}` : ""}${SUFFIX}`;

  const description = productDescription(a, categoryLabel);

  return { title, description };
}

/** Page catégorie (tous niveaux) */
export function categoryMeta(label, level, count) {
  const n = count ? `${count} références. ` : "";
  return {
    title: truncate(
      `${clean(label)} – Matériel de laboratoire${SUFFIX}`,
      MAX_TITLE + 10,
    ),
    description: truncate(
      `${clean(label)} pour laboratoire : ${n}Fournisseur indépendant depuis 1993 pour la recherche, l'enseignement et l'industrie. Demande de devis en ligne.`,
      MAX_DESC,
    ),
  };
}
